import { useI18n } from "vue-i18n";

type LocaleReturn = string | ((ctx: any) => string);

export type Locale = {
  groep: LocaleReturn;
  Groep: LocaleReturn;
  normgroep: LocaleReturn;
  "groep n": LocaleReturn;
  "groep n en n": LocaleReturn;
  "groep n tm groep n": LocaleReturn;
  "groep n t/m n": LocaleReturn;
  "begin tot eind": LocaleReturn;
  groepen: LocaleReturn;
  Groepen: LocaleReturn;
  groepsindeling: LocaleReturn;
  rt: LocaleReturn;
  rtPraktijk: LocaleReturn;
  extension: LocaleReturn;
};

export const useTranslate = () => {
  const i18n = useI18n();

  function translate(key: keyof Locale, values?: number[]): string {
    if (i18n.locale.value === "be") {
      values = values?.map((value) => value - 2);
    }

    return i18n.t(key, values ?? []);
  }

  return { t: translate };
};
